// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1FxWE","empty":"ModalGraph_empty__1W1-8"};